import * as types from '../actions/actionTypes';

let initialState = {
    findingDuplicates: {
        loading: false,
        success: true
    },
    duplicatesDetails: {
        loading: false,
        success: true,
        data: []
    },
    resolvingDuplicates: {
        loading: false,
        success: true
    }
};

export default function duplicateRecipientsReducer(state = initialState, action) {
    switch (action.type) {

        case types.START_FIND_DUPLICATE_RECIPIENTS:
            return Object.assign({}, state, { findingDuplicates: { loading: true, success: true } });
        case types.FIND_DUPLICATE_RECIPIENTS_COMPLETE:
            return Object.assign({}, state, { findingDuplicates: { ...action.response } });

        case types.START_GET_DUPLICATE_RECIPIENTS_DETAILS:
            return Object.assign({}, state, { duplicatesDetails: { ...initialState.duplicatesDetails, loading: true } });
        case types.GET_DUPLICATE_RECIPIENTS_DETAILS:
            return Object.assign({}, state, { duplicatesDetails: action.response });

        case types.START_RESOLVE_DUPLICATE_RECIPIENTS:
            return Object.assign({}, state, { resolvingDuplicates: { loading: true, success: true } });
        case types.RESOLVE_DUPLICATE_RECIPIENTS:
            return Object.assign({}, state, { resolvingDuplicates: { ...action.response } });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/DuplicateRecipientsReducer.js